export default __webpack_public_path__ + "static/media/Aegis of Dhurkan Blackblade.768bcda5.jpg";